export function LogoMark({ className = "h-8 w-auto" }) {
  return (
    <img
      src="/images/spa-logo.png"
      alt="SPA — Steven Philips & Associates Limited"
      className={className}
    />
  );
}

export default function Logo({ light = false, compact = false }) {
  return (
    <span className="flex items-center gap-3.5">
      <LogoMark
        className={compact ? "h-7 w-auto sm:h-8" : "h-8 w-auto sm:h-9"}
      />
      <span
        aria-hidden="true"
        className={`h-8 w-px ${light ? "bg-white/25" : "bg-navy/15"}`}
      />
      <span className="flex flex-col leading-none">
        <span
          className={`font-serif text-[16px] font-semibold tracking-[0.06em] sm:text-[18px] ${
            light ? "text-white" : "text-navy"
          }`}
        >
          STEVEN PHILIPS
        </span>
        <span className="mt-1 text-[8px] font-semibold uppercase tracking-[0.3em] text-gold sm:text-[9px]">
          &amp; Associates Limited
        </span>
      </span>
    </span>
  );
}
